<template lang="html">
	<div class="exchanges column">
		<div class="title">
			{{ title }}
		</div>
		<div class="exchange-part row">
			<div class="ctn-list-exchange column">
				<div class="lists-exchange">
					<div class="exchange" v-for="(thread, key) in threads" v-bind:key="key" @click="setCurrentThread(thread.id)" :class="{active: thread === currentThread}">
						<div class="date">
							{{ thread.created_at }}
						</div>
						<p class="subject">
							{{ thread.title }}
						</p>
					</div>
					<div class="exchange" v-if="!threads.length">
						Il n'y a pas encore de conversation.
					</div>
				</div>
			</div>
			<div class="exchange-content column">
				<div class="content-head row">
					<div class="subject">
						{{ currentThread.title }}
					</div>
					<div class="ctn-cta">
						<div class="btn btn-gold" @click="emitNewThread">
							Nouveau message
						</div>
						<div class="btn btn-red" @click="emitNewMessage" v-if="currentThreadId">
							Répondre
						</div>
					</div>
				</div>
				<div class="content-body">
					<div class="message row" v-for="(message, key) in currentThread.messages" v-bind:key="key">
						<div class="ctn-profile-picture">
							<img v-img-detect :src="resolveImg(message.user)" alt="">
						</div>
						<div class="body-message">
							<div class="head-message row">
								<div class="date">
									{{ message.created_at }}
								</div>
								<div class="name">
									{{ message.user.first_name }} {{ message.user.last_name }}
								</div>
							</div>
							<p class="inner-body-message" v-if="message.body">
								{{ message.body }}
							</p>
							<p class="inner-body-message" v-else>
								<span>{{ message.appointment_detail }}</span><br />
								<span>Jour(s) souhaités : {{ message.appointment_day | arrayDisplay }}</span><br />
								<span>Moment(s) de la journée souhaités : {{ message.appointment_moment | arrayDisplay }}</span><br />
								<span>Sujet(s) souhaités : {{ message.appointment_subject | arrayDisplay }}</span><br />
							</p>
						</div>
					</div>
					<div class="take-place row" v-if="!currentThread.messages.length">
						Il n'y a aucun message
					</div>
				</div>
			</div>
		</div>
		<base-modal :show="showNewThread" :data="dataNewThread" :content="modalNewThread" @close="showNewThread=false"/>
		<base-modal :show="showNewMessage" :data="dataNewMessage" :content="modalNewMessage" @close="showNewMessage=false"/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalNewThread from '@/common/components/Modal/NewThread'
import ModalNewMessage from '@/common/components/Modal/NewMessage'
export default {
	props: ['threads', 'title', 'isAdvisor'],
	data () {
		return {
			currentThreadId: null,
			modalNewThread: ModalNewThread,
			showNewThread: false,
			dataNewThread: null,
			modalNewMessage: ModalNewMessage,
			showNewMessage: false,
			dataNewMessage: null
		}
	},
	filters: {
		arrayDisplay (ar) {
			return (ar) ? ar.join(', ') : ' -'
		}
	},
	mounted () {
		this.updateNewMessageData()
	},
	methods: {
		setCurrentThread (id) {
			console.log(id)
			this.currentThreadId = id
			this.updateNewMessageData()
		},
		emitNewThread () {
			const clientId = this.$route.params.clientId
			this.dataNewThread = {
				id: clientId,
				isAdvisor: this.isAdvisor
			}
			this.showNewThread = true
		},
		emitNewMessage () {
			this.showNewMessage = true
		},
		resolveImg (u) {
			return (u.media) ? process.env.ASSETS_ROOT + u.media.file : process.env.API_ROOT + '/assets/user.png'
		},
		updateNewMessageData () {
			this.dataNewMessage = {
				isAdvisor: this.isAdvisor,
				request: {
					threadId: this.currentThread.id,
					userId: this.currentThread.client.id
				},
				side: {
					first_name: this.currentThread.client.first_name,
					last_name: this.currentThread.client.last_name
				}
			}
		},
		reverse (d) {
			return this.$iRobot.arrayClone(d).reverse()
		}
	},
	watch: {
		threads () {
			this.updateNewMessageData()
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		}),
		currentThread () {
			let current = { title: null, messages: [], client: { id: 0 } }
			this.threads.forEach((thread) => {
				if (thread.id === this.currentThreadId) {
					current = thread
				}
			})

			return current
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/chat.vue